import { render, staticRenderFns } from "./ShopWrapper.vue?vue&type=template&id=1e7fa85e&"
import script from "./ShopWrapper.vue?vue&type=script&lang=js&"
export * from "./ShopWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports